import BaseApiService from './api.base.service'
export default class ProductsApiService extends BaseApiService {
  constructor() {
    super('products')
  }

  activateProducts(productActivationId, permissions) {
    return this.callPost('/activate', {
      id: productActivationId,
      permissions: permissions,
    })
  }

  getNamesOfProductsToActiveteByProductActivationId(productActivationId) {
    return this.callGet(`${productActivationId}/to-activate/names`)
  }

  getTaxStudies(params) {
    return this.callGet('/tax-studies', params)
  }

  getElectronicPublishingByUser(params) {
    return this.callGet('/electronic-publishing/odata', params)
  }
}

export const productsApi = new ProductsApiService()
